import React,{useState,useEffect} from 'react';
import AverageMonthlyData from './AvrgMonthlyData';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import api from '../../../../Services/api';
import { Link } from "react-router-dom";
 import { FaBuilding,FaUserTie} from 'react-icons/fa';
 import { useNavigate } from 'react-router-dom';

 
export default function Index() {
   let data = sessionStorage.getItem('user');
    let assessorData = JSON.parse(data);
    let id = assessorData.id;
    const [activeDashboard, setActiveDashboard] = useState("vendor");
     const navigate = useNavigate();
  
    const [vendors, setVendors] = useState([]);
 const[loading,setLoading] = useState(true);
 const [snackbarOpen, setSnackbarOpen] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');


  
    const fetchData = async () => {
      try {
        const response = await api.vendor.getVendors(id);
        if(response.status === 200){
        setVendors(response.data.data);
        setLoading(false);
     
      }
      else if(response.status === 400){
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setVendors([])
        setLoading(false);
    }
    else if(response.status === 404){
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setVendors([])
        setLoading(false);
    }
    else if(response.status === 500){
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setVendors([])
        setLoading(false);
    }
    else{
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Some error occured, please try again")
        setVendors([])
        setLoading(false);
    }
  
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  
    const handleClickEstablishment =()=>{
  setActiveDashboard('establishment')
   navigate('/assessorestablishmentdashboard')
}
const handleClickVendor =()=>{
  setActiveDashboard('vendor')
  navigate('/assessordashboard')
}

    useEffect(() => {
      const timer = setTimeout(()=>{
      fetchData();
      },600)
      return ()=> clearTimeout(timer)
    }, [id]);
  return (
    <div>
        <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
      
              }}
              severity="success"
              open={snackbarOpen}
              autoHideDuration={2000}
              onClose={() => setSnackbarOpen(false)}
              sx={{
                marginTop: '2.9%',
                marginRight: '7%'
              }}
            >
              <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              severity="error"
              open={errorSnackbarOpen}
              autoHideDuration={2000}
              sx={{
                marginTop: '2.9%',
                marginRight: '7%'
              }}
              onClose={() => { setErrorSnackbarOpen(false) }}
            >
              <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
            </Snackbar>
               <section
                    className="d-flex justify-content-between align-items-center px-4 py-2"
                    
                  >
                    {/* Left side: Legend */}
                    <div className="d-flex align-itemster" style={{ letterSpacing: "1px" }}>
                      <div
                        style={{
                          backgroundColor: "#50c878",
                          width: "15px",
                          height: "15px",
                          display: "inline-block",
                          marginRight: "4px",
                          borderRadius: "50%",
                        }}
                      ></div>
                      <span style={{ fontSize: "14px" }}>Accepted</span>
                  
                      <div className="vr mx-3"></div>
                  
                      <div
                        style={{
                          backgroundColor: "#B22222",
                          width: "15px",
                          height: "15px",
                          display: "inline-block",
                          marginRight: "4px",
                          borderRadius: "50%",
                        }}
                      ></div>
                      <span style={{ fontSize: "14px" }}>Rejected</span>
                  
                      <div className="vr mx-3"></div>
                  
                      <div
                        style={{
                          backgroundColor: "#EFCC00",
                          width: "15px",
                          height: "15px",
                          display: "inline-block",
                          marginRight: "4px",
                          marginLeft: "8px",
                          borderRadius: "50%",
                        }}
                      ></div>
                      <span style={{ fontSize: "14px" }}>Under review</span>
                  
                      <div className="vr mx-3"></div>
                  
                      <div
                        style={{
                          backgroundColor: "lightgray",
                          width: "15px",
                          height: "15px",
                          display: "inline-block",
                          marginRight: "4px",
                          borderRadius: "50%",
                        }}
                      ></div>
                      <span style={{ fontSize: "14px" }}>Not Uploaded</span>
                    </div>
                  
                  <div className="flex gap-2">
  <button
    title="Establishment Compliance"
    onClick={handleClickEstablishment}
    className={`flex items-center gap-2 px-3 py-2 rounded-full transition-all duration-300 cursor-pointer
      ${activeDashboard === 'establishment' 
        ? 'bg-success text-white opacity-70' 
        : 'bg-success text-white hover:px-5'}`}
    disabled={activeDashboard === 'establishment'}
  >
    <FaBuilding />
    {activeDashboard === 'establishment' && (
      <span>Establishment Compliance</span>
    )}
  </button>

  <button
    title="Vendor Compliance"
    onClick={handleClickVendor}
    className={`flex items-center gap-2 px-3 py-2 rounded-full transition-all duration-300 cursor-pointer
      ${activeDashboard === 'vendor' 
        ? 'bg-danger text-white opacity-70' 
        : 'bg-danger text-white hover:px-5'}`}
    disabled={activeDashboard === 'vendor'}
  >
    <FaUserTie />
    {activeDashboard === 'vendor' && (
      <span>Vendor Compliance</span>
    )}
  </button>
</div>

                  </section>
            {loading ? (
               <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
               <h3>Loading</h3>
      <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div> 
      <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
      <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
      
      </div>
            ) : (
            vendors && vendors.length > 0 ? (
              <>
  <AverageMonthlyData/>
  </>
            ) : (
              <>
            
        <div style={{marginTop:"60px"}}>
          <p className="text-center">No Vendors Found !! <Link to="/createVendor" className="text-danger">Click here</Link> to Create</p>
        </div>
        </>
            )
          )}
    </div>
          )
        }
